import { Input } from "antd";
import React from "react";

export default function PhoneNumberFormatter(props) {

  const {
    country = "",
    value = "",
    onChange = () => { },
    display = false,
    ...rest
  } = props;


  const formatPhoneNumber = (_value, _country) => {
    

    if (!_value) {
      return _value;
    }

    // no formatting if not Canada / US
    if (_country !== "Canada" && _country !== "United States") {
      return _value;
    }

    // numbers only
    let value = _value.toString().replace(/[^\d]/g, '');

    // remove leading country code
    if (value.length > 10 && value.substr(0, 1) === "1") {
      value = value.substr(1, 10);
    }

    // trim to 10 digits
    value = value.substr(0, 10);

    if (value.length < 4) {
      return value;
    }

    if (value.length < 7) {
      return `(${value.slice(0, 3)}) ${value.slice(3)}`;
    }

    return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
  };


  const change = (e) => {

    const formatted = formatPhoneNumber(
      e.target.value,
      country
    );

    e.target.value = formatted;

    onChange(e);
  };


  if (display) {
    return formatPhoneNumber(value, country);
  }

  return (
    <Input
      {...rest}
      value={value}
      onChange={change}
      name="tel"
      type="tel"
      autoComplete="tel"
      inputMode="tel"
      aria-label="Enter Phone Number"
      size="large"
      minLength={10}
      maxLength={15}
    />
  );
}